<template>
    <div class="container-fluid" >
        <div class="row justify-content-between">
            <div class="col"><h3>Оюутнууд</h3></div>
            <div class="col-auto">
                <router-link to="/studentadd/new">
                    <div class="btn btn-success">Оюутан нэмэх</div>
                </router-link>
                <router-link to="/studentsadd">
                    <div class='btn btn-danger ml-2'>Оюутнуудын мэдээлэл нэмэх</div>
                </router-link>
            </div>
        
        </div>
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Оюутны жагсаалт</h6>
            </div>
            <div class="card-body">
                <div class="table-responsive" v-if="students!=null && students.length>0">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Овог/Нэр</th>

                        <th>Оюутны код</th>
                        <th>Хөтөлбөр</th>
                        <th>Регистр</th>
                        <th>Төлөв</th>
                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(student, index) in students" v-bind:key="student.id">
                            <td>{{index+1}}</td>
                            <td>{{student.lastname}}/{{student.name}}</td>
                            <td>{{student.code}}</td>
                            <td>
                                <div >
                                    <span v-if="student.school!=null">{{student.school.id}}</span>
                                    <span v-else>Сургууль сонгоогүй байна.</span>
                                </div>
                                <div >
                                    <span v-if="student.department!=null">{{student.department.id}}</span>
                                    <span v-else>Тэнхим сонгоогүй байна.</span>
                                </div>
                                <div >
                                    <span v-if="student.program!=null">{{student.program.id}}</span>
                                    <span v-else>Хөтөлбөр сонгоогүй байна.</span>
                                </div>
                            </td>
                            <td>{{student.register}}</td>
                            <td>
                                <span v-if="student.user==null || student.user==undefined" class="badge badge-danger">Системд холбогдоогүй</span>
                                <span v-else class="badge badge-success">Системд холбогдсон</span>
                            </td>
                            <td>
                                <button class="btn btn-success btn-sm" @click="$router.push({ name: 'StudentDetail', params: { studentId: student.id} })">харах</button>
                                <button class="btn btn-warning btn-sm ml-2" @click="_edit(student)">засах</button>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
                <button v-if="loading==false" @click="getStudentsData()" class="btn btn-success btn-block">Load More</button>
                <button v-else type="button" class="btn btn-success btn-block" disabled>
                    <span class="spinner-border spinner-border-sm"></span>
                    Loading..
                </button>
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор оюутны мэдээлэл ороогүй байна.</div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')

    export default {
        data() {
            return {
               students:[],
               lastVisible:null,
               loading:false,
               last:false

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {
            _getStudents(){
                // fb.db.collection("lessons").where("published", "==", true).get().then(querySnapshot=> {
                //     console.log(querySnapshot.size);
                // });
                this.getStudentsData();
            },
            _edit(student){
                this.$router.push({ name: 'StudentAdd', params: { studentId: student.id} })
            },
            async getStudentsData(){
                if(this.last==false){
                    this.loading=true;
                    var query;
                    if(this.lastVisible==null)
                    
                        query=fb.db.collection("students").orderBy("createdAt",'desc').limit(50);
                    
                    else
                        query=fb.db.collection("students").orderBy("createdAt", 'desc').startAfter(this.lastVisible).limit(50);
                    
                    if(query!=null){
                        var documentSnapshots=await query.get();
                        this.lastVisible= documentSnapshots.docs[documentSnapshots.docs.length-1];
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data();
                            object.id = doc.id;
                            this.students.push(object);
                        });
                        if(documentSnapshots.size!=50)
                            this.last=true;
                    }
                    this.loading=false;
                }
               
            }

  
        },
        created() {
            this.students=[];

            this._getStudents();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
